import {useIntl} from 'react-intl';
import {matrixService} from '../../../services/matrixService';
import {useGroupCallState, useGroupCallUi, useRtcFeatures} from '../../groupCalls/hooks/useGroupCall';
import {CallBubble} from '../components/CallBubble';
import {CallSurfaceBoundary} from '../components/CallSurfaceBoundary';
import type {GroupCallLeg} from '../model/types';
import {GroupFailedBubble, GroupIncomingBubble} from './GroupBubbleViews';
import {GroupCallSurface} from './GroupCallSurface';
import {GroupPrep} from '../prep/GroupPrep';
import {SwitchingOverlay} from './GroupInvite';
import {groupSurfaceMessages as m} from './groupMessages';

export const GroupSurfaces = ({leg, expanded}: {leg?: GroupCallLeg; expanded: boolean}) => {
    const intl = useIntl();
    const state = useGroupCallState();
    const ui = useGroupCallUi();
    const features = useRtcFeatures();
    const roomName = state.roomId ? matrixService.getRoom(state.roomId)?.name || state.roomId : '';

    return (
        <>
            {ui.switching && <SwitchingOverlay switching={ui.switching}/>}
            {state.phase === 'lobby' && !ui.switching && (
                <GroupPrep key={state.roomId} state={state} roomName={roomName} notice={ui.notice} preparing={ui.preparing} videoAvailable={features.videoCalls}/>
            )}
            {(state.phase === 'failed' || ui.switchFailed) && !ui.switching && (
                <CallSurfaceBoundary resetKey={`failed:${state.roomId ?? ''}`}>
                    <CallBubble tone="call" urgent label={roomName} testId="group-call-failed-bubble">
                        <GroupFailedBubble state={state} switchFailed={ui.switchFailed}/>
                    </CallBubble>
                </CallSurfaceBoundary>
            )}
            {leg?.phase === 'incoming' && (
                <CallSurfaceBoundary resetKey={leg.id}>
                    <CallBubble tone="call" urgent label={intl.formatMessage(m.incomingRegion, {name: leg.identity.name ?? ''})} testId="group-call-ring-bubble">
                        <GroupIncomingBubble leg={leg} videoAvailable={features.videoCalls}/>
                    </CallBubble>
                </CallSurfaceBoundary>
            )}
            {leg && leg.phase !== 'incoming' && <GroupCallSurface key={leg.id} leg={leg} expanded={expanded}/>}
        </>
    );
};
